// src/components/sections/Hero.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../data/translations';
import { motion } from 'framer-motion';

const Hero = () => {
  const { darkMode } = useTheme();
  const { language } = useLanguage();
  const t = translations[language];
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="accueil" className="pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-8 md:mb-0">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: visible ? 1 : 0, y: visible ? 0 : -20 }}
              transition={{ duration: 0.7 }}
            >
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                {t["hero.title"]}
              </h1>
              <p className="text-xl mb-6">
                {language === 'fr' ? (
                  <>
                    Expert en{" "}
                    <span className={darkMode ? "text-blue-400" : "text-blue-600"}>
                      Spring Boot
                    </span>
                    ,{" "}
                    <span className={darkMode ? "text-green-400" : "text-green-600"}>
                      React Native
                    </span>
                    ,{" "}
                    <span className={darkMode ? "text-cyan-400" : "text-cyan-600"}>
                      React JS
                    </span>{" "}
                    et{" "}
                    <span className={darkMode ? "text-orange-400" : "text-orange-600"}>
                      DevOps
                    </span>
                  </>
                ) : (
                  <>
                    Expert in{" "}
                    <span className={darkMode ? "text-blue-400" : "text-blue-600"}>
                      Spring Boot
                    </span>
                    ,{" "}
                    <span className={darkMode ? "text-green-400" : "text-green-600"}>
                      React Native
                    </span>
                    ,{" "}
                    <span className={darkMode ? "text-cyan-400" : "text-cyan-600"}>
                      React JS
                    </span>{" "}
                    and{" "}
                    <span className={darkMode ? "text-orange-400" : "text-orange-600"}>
                      DevOps
                    </span>
                  </>
                )}
              </p>
              <p className="text-gray-500 dark:text-gray-400 mb-8">
                {t["hero.description"]}
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="projets"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className={`px-6 py-3 rounded-lg ${
                      darkMode
                        ? "bg-blue-600 hover:bg-blue-700"
                        : "bg-blue-500 hover:bg-blue-600"
                    } text-white transition-colors duration-200`}
                  >
                    {t["hero.cta.projects"]}
                  </motion.button>
                </Link>
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className={`px-6 py-3 rounded-lg border ${
                      darkMode
                        ? "border-gray-600 hover:bg-gray-800"
                        : "border-gray-300 hover:bg-gray-100"
                    } transition-colors duration-200`}
                  >
                    {t["hero.cta.contact"]}
                  </motion.button>
                </Link>
              </div>
            </motion.div>
          </div>
          <div className="md:w-1/2 flex justify-center">
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: visible ? 1 : 0, x: visible ? 0 : 20 }}
              transition={{ duration: 0.7, delay: 0.3 }}
            >
              <div
                className={`w-64 h-64 md:w-80 md:h-80 rounded-full relative overflow-hidden border-4 ${
                  darkMode ? "border-blue-600" : "border-blue-500"
                }`}
              >
                <img
                  src="/assets/images/mon-profil.png"
                  alt="Profil"
                  className="w-full h-full object-cover"
                />
                <div
                  className={`absolute inset-0 flex items-center justify-center bg-opacity-80 ${
                    darkMode ? "bg-gray-900" : "bg-white"
                  } opacity-0 hover:opacity-100 transition-opacity duration-300`}
                >
                  <div className="text-center p-4">
                    <p className="font-bold text-lg mb-2">IGOR SIBEMOU</p>
                    <p className={darkMode ? "text-blue-400" : "text-blue-600"}>
                      {t["about.job"]}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;